import { ContentTab, ContentTabs } from 'components/v2/Content'
import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

export enum EBusinessClientUserTab {
  Users = 'users'
}

interface IBusinessClientUsersTabsProps {
  activeTab: EBusinessClientUserTab
}

export const BusinessClientUsersTabs = ({ activeTab }: IBusinessClientUsersTabsProps): ReactElement => {
  return (
    <ContentTabs>
      <ContentTab isActive={activeTab === EBusinessClientUserTab.Users}>
        <FormattedMessage id="businessClientUsers.tabs.users" defaultMessage="Users" />
      </ContentTab>
    </ContentTabs>
  )
}
